<div [ngClass]="{'allocation':isAllocationSheet()}" class="assign-plant">
    <div style="  opacity: 0;
  pointer-events: none;
  height: 0px;">
        <mat-form-field>
            <mat-select [formControl]="plantsFormCtrl"
                        [multiple]="true"
                        #plantsSelector>
                <mat-option>
                    <ngx-mat-select-search
                        noEntriesFoundLabel="No results found"
                        placeholderLabel="Find a plant..."
                        [formControl]="plantsFilterFormCtrl">
                    </ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let plant of filteredPlants | async"
                            [value]="plant"
                            (click)="addOrRemovePlant(plant)">
                    {{ plant.description }} ({{ plant.serialNumber}})
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <table class="table table-borderless rows-no-padding">
        <tr *ngFor="let plant of plantsFormCtrl?.value" [ngClass]="{'allocation':isAllocationSheet()}" class="table-row">
            <td class="align-middle">
                <i class="fas fa-check-square main-color margin-right-5"></i>
                {{ plant.description }} ({{ plant.serialNumber}})
            </td>
            <td class="align-middle text-sm-right">
                <input
                    *ngIf="!isAllocationSheet()"
                    class="form-control form-control-sm float-right no-border"
                    [(ngModel)]="plant.hours"
                    [disabled]="controlDisabled"
                    (blur)="updateAllocatedPlantsList()"
                    style="max-width: 80px"
                    oninput="(this.value == '' ? this.value = 0 : '')"
                    step=".01"
                    type="number" min="1" max="24" required/>
                <span *ngIf="isAllocationSheet()">{{ plant.hours }}</span>
            </td>
            <td class="align-middle">
                <button class="btn btn-sm"
                        *ngIf="!isAllocationSheet()"
                        [disabled]="controlDisabled"
                        (click)="removeItem(plant.id)">
                    <i class="fa fa-trash"></i>
                </button>
            </td>
        </tr>
    </table>

    <button class="btn btn-default"
            *ngIf="!isAllocationSheet()"
            [disabled]="controlDisabled"
            (click)="plantsSelector.open()">
        <i class="fas fa-plus"></i> {{ l('Add') }}
    </button>

    <button class="btn btn-default"
            *ngIf="isAllocationSheet()"
            [disabled]="controlDisabled"
            (click)="edit()">
        <i class="fas fa-edit"></i> {{ l('Edit') }}
    </button>
    <div class="validation-msg" *ngIf="showError() && !anyResourceSelected">{{ l('MinResourceSelectionCriteria') }}</div>
</div>
